/**
 * Códigos de PERMISO (RBAC · Ruta B) · espejo del catálogo del backend
 * (`Multiva.Shared.Application.Authorization.Permisos`). Se usan para el gateo
 * de UI: `<PermissionGate>` y los items del nav. Deben mantenerse en sincronía
 * con el backend (son las mismas cadenas estables `grupo.accion`).
 *
 * El backend es la frontera de seguridad real; esto solo decide qué se MUESTRA.
 */
export const PERMISOS = {
  // Solicitudes
  solicitudesGestionar: "solicitudes.gestionar",
  facturasVer: "facturas.ver",
  catalogosSolicitar: "catalogos.solicitar",
  notificacionesVer: "notificaciones.ver",
  contrapagosGestionar: "contrapagos.gestionar",
  // Autorización
  autorizacionAutorizar: "autorizacion.autorizar",
  autorizacionRechazar: "autorizacion.rechazar",
  autorizacionDarDeBaja: "autorizacion.dar_de_baja",
  calendarioPagosVer: "calendario_pagos.ver",
  calendarioPagosReprogramar: "calendario_pagos.reprogramar",
  // Contabilización
  contabilizacionReintentar: "contabilizacion.reintentar",
  // Consulta
  solicitudesVerTodas: "solicitudes.ver_todas",
  historicoDocumentalVer: "historico_documental.ver",
  auditoriaVer: "auditoria.ver",
  // Administración
  adminOrganizaciones: "admin.organizaciones",
  adminUsuarios: "admin.usuarios",
  adminRoles: "admin.roles",
  adminModulos: "admin.modulos",
  adminPermisos: "admin.permisos",
  adminAreas: "admin.areas",
  adminFlujosAutorizacion: "admin.flujos_autorizacion",
  adminProveedores: "admin.proveedores",
  adminCatalogosContables: "admin.catalogos_contables",
  adminCatalogosSat: "admin.catalogos_sat",
  adminEquivalenciasUnidad: "admin.equivalencias_unidad",
  adminIndicadoresImpuesto: "admin.indicadores_impuesto",
  adminProrrateoAutomatico: "admin.prorrateo_automatico",
  adminMapeosClaveCuenta: "admin.mapeos_clave_cuenta",
  adminClaveSatCentroCosto: "admin.clave_sat_centro_costo",
  adminTiposDocumento: "admin.tipos_documento",
  adminCategoriasDocumento: "admin.categorias_documento",
  /** Gestión Documental (fase 2) · categorías, tipos, requisitos y reglas de revisión. */
  adminGestionDocumental: "admin.gestion_documental",
  adminConfiguraciones: "admin.configuraciones",
  adminComprasSap: "admin.compras_sap",
  adminSatMock: "admin.sat_mock",
  adminSolicitudesCatalogo: "admin.solicitudes_catalogo",
  /** Configurar los tipos de solicitud de catálogo (responsables, textos, atención automática). */
  adminTiposSolicitudCatalogo: "admin.tipos_solicitud_catalogo",
  adminPlazo: "admin.plazo",
  adminNotificaciones: "admin.notificaciones",
  /** Hotspot 55 · eventos del outbox que fallaron (pantalla «Eventos fallidos»). */
  adminEventosFallidos: "admin.eventos_fallidos",
  // Reportería
  reporteriaUsar: "reporteria.usar",
  /** Hotspot 92 · crear reportes personalizados (guardar plantillas y columnas personalizadas). */
  reporteriaPersonalizar: "reporteria.personalizar",
  reporteriaAdministrar: "reporteria.administrar",
} as const;

/** Ver una solicitud (propia o todas) · para pantallas compartidas. */
export const VER_SOLICITUDES = [PERMISOS.solicitudesGestionar, PERMISOS.solicitudesVerTodas];

/** Todos los permisos de Administración + auditoría · para el hub `/admin`. */
export const PERMISOS_ADMIN = [
  PERMISOS.adminOrganizaciones, PERMISOS.adminUsuarios, PERMISOS.adminRoles, PERMISOS.adminModulos, PERMISOS.adminPermisos, PERMISOS.adminAreas,
  PERMISOS.adminFlujosAutorizacion, PERMISOS.adminProveedores, PERMISOS.adminCatalogosContables,
  PERMISOS.adminCatalogosSat, PERMISOS.adminEquivalenciasUnidad, PERMISOS.adminIndicadoresImpuesto, PERMISOS.adminProrrateoAutomatico,
  PERMISOS.adminMapeosClaveCuenta, PERMISOS.adminClaveSatCentroCosto, PERMISOS.adminTiposDocumento, PERMISOS.adminCategoriasDocumento, PERMISOS.adminGestionDocumental,
  PERMISOS.adminConfiguraciones, PERMISOS.adminComprasSap, PERMISOS.adminSatMock,
  PERMISOS.adminSolicitudesCatalogo, PERMISOS.adminPlazo, PERMISOS.adminNotificaciones, PERMISOS.adminEventosFallidos, PERMISOS.reporteriaAdministrar,
  PERMISOS.auditoriaVer,
];

/** Gestión Documental (fase 2) · categorías: el permiso nuevo o el histórico del catálogo. */
export const PERMISOS_CATEGORIAS_DOCUMENTO = [PERMISOS.adminGestionDocumental, PERMISOS.adminCategoriasDocumento];
/** Gestión Documental (fase 2) · tipos de documento: el permiso nuevo o el histórico del catálogo. */
export const PERMISOS_TIPOS_DOCUMENTO = [PERMISOS.adminGestionDocumental, PERMISOS.adminTiposDocumento];
